module.exports = __webpack_public_path__ + "img/notice-yl.ba5bc697.jpg";